module.exports = __webpack_public_path__ + "img/caiji-type-1-5.6f869f4e.png";